export default "__VITE_ASSET__Fzj6gvet__"